import React from 'react';
import { withRouter } from 'react-router';
import { checkPermission } from '../utils_v2/'
import { UsersIcon, PendingUsersIcon, RolesIcon, ProfilesIcon } from './NavIcons';
import CollapsibleSideNav from './CollapsibleSideNav';
const SettingsNavWrapper = ({ location }) => {
    const path = location.pathname || '';
    const canManageUsers = checkPermission('settings', 'manage_user', 'R');
    const navItems = [
        // user detail pages (/users/:id) belong to User(s)
        { label: 'User(s)', to: '/users/manage', icon: UsersIcon, show: canManageUsers, active: path.startsWith('/users') && !path.startsWith('/users/invites') },
        { label: 'Pending User(s)', to: '/users/invites/', icon: PendingUsersIcon, show: canManageUsers, active: path.startsWith('/users/invites') },
        { label: 'Role(s)', to: '/settings/roles', icon: RolesIcon, show: checkPermission('settings', 'custom_roles', 'R'), active: path.startsWith('/settings/roles') },
        { label: 'Profile(s)', to: '/settings/profile', icon: ProfilesIcon, show: checkPermission('settings', 'profile_order', 'R'), active: path.startsWith('/settings/profile') },
    ];
    return (
        <CollapsibleSideNav storageKey='settingsNavCollapsed' navItems={navItems} showPageTitle />
    )
}
export default withRouter(SettingsNavWrapper)
